"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", { value: true });
const RelayMessage_1 = require("./RelayMessage");
function Web3RequestCanceledMessage(id) {
    return { type: RelayMessage_1.RelayMessageType.WEB3_REQUEST_CANCELED, id };
}
exports.Web3RequestCanceledMessage = Web3RequestCanceledMessage;
